import loadable from 'components/dynamic-import';

export const Checkout = loadable(() => import('./Checkout'));
export const TransparentCheckout = loadable(() => import('./TransparentCheckout'));
export type { PaymentProviderCheckout } from './types';
